import React from 'react';
import { ModalContextType, ModalType, useModalContext } from 'src/hooks/useModal';
import { ScrollModal } from '../../../components/primitives/ScrollModal';
import { MulticallUpdater } from '../../../components-yldr/LiquidityChartRangeInput/state/multicall';
import { PositionModalWrapper } from '../FlowCommons/PositionModalWrapper';
import { AutoExitModalContent } from './AutoExitModalContent';

export const AutoExitModal = () => {
  const { type, args, close } = useModalContext() as ModalContextType<{
    positionAddress: string;
  }>;

  return (
    <ScrollModal open={type === ModalType.AutoExit} setOpen={close}>
      <PositionModalWrapper
        positionAddress={args.positionAddress}
        modernStyle={true}
      >
        {(params) => <AutoExitModalContent {...params} />}
      </PositionModalWrapper>
      <MulticallUpdater />
    </ScrollModal>
  );
};
